<script setup>
import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import { useModelWrapper } from '@/Shared/Composables/useModelWrapper'

const props = defineProps({
  utc: {
    type: Boolean,
    default: true,
  },
  placeholder: {
    type: String,
    default: 'Select',
  },
  enableTimePicker: {
    type: Boolean,
    default: false,
  },
  format: {
    type: String,
    default: 'dd/MM/yyyy',
  },
  modelValue: {
    type: [Date, String],
    default: null,
  },
  minDate: {
    type: [Date, String],
    default: null,
  },
  minTime: {
    type: Object,
    default: null,
  },
})

const emits = defineEmits(['update:modelValue'])

const value = useModelWrapper(props, emits)
</script>

<template>
  <VueDatePicker
    v-model="value"
    :utc="utc"
    :placeholder="placeholder"
    :enable-time-picker="true"
    :time-picker-inline="true"
    :month-change-on-scroll="false"
    :min-date="minDate"
    :min-time="minTime"
    auto-apply
    arrow-navigation
    :format="format"
    calendar-cell-class-name="app-datepicker-calendar  focus:ring-secondary focus:border-secondary  text-sm font-sans"
    input-class-name="datepicker-input border-black  shadow-sm focus:border-2 focus:ring focus:ring-yellow-500"
    menu-class-name="app-datepicker-menu p-4"
  />
</template>

<style>
.dp__theme_light,
.dp__theme_dark {
  --dp-background-color: #ffffff;
  --dp-text-color: #212121;
  --dp-hover-color: #f3f3f3;
  --dp-hover-text-color: #212121;
  --dp-hover-icon-color: #959595;
  --dp-primary-color: var(--secondary-color);
  --dp-primary-text-color: #e97135;
  --dp-secondary-color: #c0c4cc;
  --dp-border-color: #000000;
  --dp-ring-secondary: ##f6cb32;
  --dp-border-color-hover: #000000;
  --dp-menu-border-color: #000000;
  --dp-disabled-color: #f6f6f6;
  --dp-scroll-bar-background: #f3f3f3;
  --dp-scroll-bar-color: #959595;
  --dp-success-color: #76d275;
  --dp-success-color-disabled: #a3d9b1;
  --dp-icon-color: #959595;
  --dp-danger-color: #ff6f60;
}

.datepicker-input {
  padding-top: 0.5rem;
  padding-right: 0.75rem;
  padding-bottom: 0.5rem;
  padding-left: 2.3rem;
  font-family: Lexend;
  width: 100%;
}

.app-datepicker-menu .dp__calendar_header_item {
  font-family:
    ui-sans-serif,
    system-ui,
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    Roboto,
    'Helvetica Neue',
    Arial,
    'Noto Sans',
    sans-serif,
    'Apple Color Emoji',
    'Segoe UI Emoji',
    'Segoe UI Symbol',
    'Noto Color Emoji';
  font-weight: 600;
}
</style>
